<template>
  <router-view />
</template>

<script>
export default {
  name: 'BaseAmdmin'
};
</script>

<style></style>
